import { Tag, TagLabel } from "@chakra-ui/react";
import { PropsWithChildren } from "react";

export default function SimpleTag({
  children,
}: PropsWithChildren) {
  return (
    <Tag size="sm" variant="outline" colorScheme="gray" boxShadow="inset 0 0 0px .5px" color="content.tertiary">
      <TagLabel>
        {children}
      </TagLabel>
    </Tag>
  );
}
